(function ($) {

  //Link button Creator
  Drupal.behaviors.linkButton = {
		    attach: function (context) {
		    		Drupal.behaviors.linkButtonCreator(context);
		    }
  }

  Drupal.behaviors.linkButtonCreator = function (context){
      //<div class="linkButton" data-text="My Link" data-url="www.hanseatics.com" data-position-right="true"
      //    data-arrow-color="white" data-arrow-background-color="red"
      //    data-text-class="link-primary" data-text-color="black" data-is-small="true" data-edge-mode-class="linkButton-edge">
  	//OPTIONAL: data-has-margin-top
  		$(".linkButton", context).each(function (index){
  		var isPositionRight = $(this).data( "position-right" );
	    	var arrowColor = $(this).data( "arrow-color" );
	    	var arrowBackgroundColor = $(this).data( "arrow-background-color" );
	    	var background = $(this).data( "background-class" );
	    	var text = $(this).data( "text" );
	    	var smallText = $(this).data( "small-text" ) || text;
	    	var link = $(this).data( "url" );
	    	var textClass = $(this).data( "text-class" );
	    	var textColor = $(this).data( "text-color" );
	    	var isSmallButton = $(this).data( "is-small" );
	    	var hasMarginTop = $(this).data( "has-margin-top" );
	    	var isCloseButton = $(this).data( "is-close" );
	    	/*
	    	 * Edge Mode makes the arrow button stay at the edge of the width:
	    	 * linkButton-edge on all sizes xs sm md and lg
	    	 * linkButton-edge-xs only shows the behavior in xs size
	    	 */
	    	var edgeModeClass = $(this).data("edge-mode-class");
	    	var targetForLink = $(this).data("target"); //in case you want to add an specifc target

	    	var isAlreadyModified = $(this).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	var rotationClass = "";
	    	if(!isPositionRight){
	    		rotationClass = "link-arrow-right-rotation";
	    	}
	    	var arrowSizeClass = "";

	    	var topOffset = 0;

	    	var arrowBigSVG = '\
	    		<?xml version="1.0" encoding="UTF-8"?>\
	    		<svg class="arrow-button iconSVG \
	    		' + rotationClass + '\
	    		"width="48px" height="48px" style="border-radius:24px;" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
	    		    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\
	    		    <title>Buttons/Circle/Large</title>\
	    		    <desc>Created with Sketch.</desc>\
	    		    <defs>\
	    		    </defs>\
	    		    <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
	    		        <g id="Buttons/Circle/Large">\
	    		            <g id="CircleButtonLarge">\
	    		                <g id="circle-mask"></g>\
	    		                <g id="color/white/100" fill="#FFFFFF" \
		                    	class="' + arrowBackgroundColor  + "-fill" + '"\
		                    	>\
	    		                		<rect id="white" x="0" y="0" width="48" height="48"></rect>\
	    		                </g>\
	    		                <g id="Icons/Arrow/Red">\
	    		                    <g transform="translate(16.000000, 18.000000)" id="arrow-icn-red">\
	    		                        <g transform="translate(0.071111, 0.000000)">\
	    		                            <path d="M3.97903932e-13,6.5 L14.9333333,6.5" id="Path-2" stroke="#DE0000" \
	    		                            	class="' + arrowColor + "-stroke" + '"\
	    		                            	></path>\
	    		                            <polyline id="Path-3" stroke="#DE0000" points="8.53333333 0 14.9333333 6.5 8.53333333 13" \
	    		                            	class="' + arrowColor + "-stroke" + '"\
	    		                            	></polyline>\
	    		                        </g>\
	    		                    </g>\
	    		                </g>\
	    		            </g>\
	    		        </g>\
	    		    </g>\
	    		</svg>';

		    	var arrowSmallSVG = '\
			    	<?xml version="1.0" encoding="UTF-8"?>\
			    	<svg class="arrow-button iconSVG top-2\
		    			' + rotationClass + '\
		    			" width="16px" height="16px" style="border-radius:8px;" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
			    	<!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\
			    	    <title>Buttons/Circle/Small</title>\
			    	    <desc>Created with Sketch.</desc>\
			    	    <defs>\
			    	    </defs>\
			    	    <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
			    	        <g id="Buttons/Circle/Small">\
			    	            <g id="CircleButtonSmall">\
				    	        <mask id="mask-2-small" maskUnits="userSpaceOnUse"\
			    	            x="0" y="0" width="16" height="16">\
			    				<circle cx="8" cy="8" r="8" fill="white"></circle>\
			    					</mask>\
			    	                <g id="circle-mask"></g>\
			    	                <g id="color/white/100" fill="#FFFFFF"\
			    	                	class="' + arrowBackgroundColor  + "-fill" + '"\
			    	                	>\
			    	                    <rect id="white" x="0" y="0" width="16" height="16"></rect>\
			    	                </g>\
			    	                <g id="Icons/Arrow/Red">\
			    	                    <g transform="translate(4.000000, 5.000000)" id="arrow-icn-red">\
			    	                        <g transform="translate(0.035556, 0.000000)">\
			    	                            <path d="M3.97903932e-13,3 L7.46666667,3" id="Path-2" stroke="#DE0000"\
			    	                            	class="' + arrowColor + "-stroke" + '"\
			    	                            	></path>\
			    	                            <polyline id="Path-3" stroke="#DE0000" points="4.26666667 0 7.46666667 3 4.26666667 6"\
			    	                            	class="' + arrowColor + "-stroke" + '"\
			    	                            	></polyline>\
			    	                        </g>\
			    	                    </g>\
			    	                </g>\
			    	            </g>\
			    	        </g>\
			    	    </g>\
			    	</svg>';

		    	var arrowSmallCloseSVG = '\
			    	<?xml version="1.0" encoding="UTF-8"?>\
		    		<svg class="arrow-button iconSVG top-2\
	    			' + rotationClass + '\
	    			" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
		    	    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\
		    	    <title>Buttons/Circle/close</title>\
		    	    <desc>Created with Sketch.</desc>\
		    	    <defs>\
		    	        <circle id="path-1" cx="8" cy="8" r="8"></circle>\
		    	    </defs>\
		    	    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
		    	        <g id="Buttons/Circle/close">\
		    	            <g id="CircleButtonLarge">\
		    	                <mask id="mask-2" fill="white">\
		    	                    <use xlink:href="#path-1"></use>\
		    	                </mask>\
		    	                <g id="circle-mask"></g>\
		    	                <g id="color/red/100" mask="url(#mask-2)" fill="#EF4438" class="' + arrowBackgroundColor  + "-fill" + '">\
		    	                    <rect id="white-copy" x="0" y="0" width="16" height="16"></rect>\
		    	                </g>\
		    	                <g id="Icons/Close-white" mask="url(#mask-2)">\
		    	                    <g transform="translate(4.000000, 4.000000)" id="Group">\
		    	                        <g transform="translate(4.000000, 4.000000) rotate(45.000000) translate(-4.000000, -4.000000) ">\
		    	                            <g id="arrow-icn-red" transform="translate(0.000000, 3.428571)" stroke="#FFFFFF" class="' + arrowColor + "-stroke" + '">\
		    	                                <path d="M3.98348021e-13,0.571428571 L8,0.571428571" id="Path-2"></path>\
		    	                            </g>\
		    	                            <g id="arrow-icn-red" transform="translate(4.000000, 4.000000) rotate(90.000000) translate(-4.000000, -4.000000) translate(0.000000, 3.428571)" stroke="#FFFFFF"\
		    								class="' + arrowColor + "-stroke" + '">\
		    	                                <path d="M4.58744154e-13,0.571428571 L8,0.571428571" id="Path-2"></path>\
		    	                            </g>\
		    	                        </g>\
		    	                    </g>\
		    	                </g>\
		    	            </g>\
		    	        </g>\
		    	    </g>\
		    	    </svg>';


	    	var arrowSVG = "";
		if(!isCloseButton){
		    	if(!isSmallButton) {
		    		arrowSVG = arrowBigSVG;
		    		arrowSizeClass = "iconSaph-48x48";
		    		topOffset = 24;
		    	} else {
		    		arrowSVG = arrowSmallSVG;
		    		arrowSizeClass = "iconSaph-16x16";
		    		topOffset = 10;
		    	}
		}else{
    			arrowSVG = arrowSmallCloseSVG;
    			arrowSizeClass = "iconSaph-16x16";
    			topOffset = 10;
		}

	    	var fullContentsHTML = '<div class="linkMainContainer';
	    	if(hasMarginTop){
	    		fullContentsHTML += ' link-margin-top ';
	    	}
	    	if(isPositionRight && edgeModeClass){
	    		$(this).addClass(edgeModeClass);
	    	}else{
	    		fullContentsHTML += ' singleElement ';
	    	}
	    	fullContentsHTML += '">'; //Inner div
	    	if(link){
	    		if(!targetForLink){
	    			fullContentsHTML += '<span class="cursor-pointer clickSection"><a href="' + link + '">';
	    		} else{
	    			fullContentsHTML += '<span class="cursor-pointer clickSection"><a href="' + link + '" target="' + targetForLink + '">';
	    		}
	    	} else {
	    		fullContentsHTML += '<span class="cursor-pointer clickSection">';
	    	}

	    	if(!isPositionRight)
	    	{
	    		fullContentsHTML += '<div class="linkButtonDiv link-arrow-right hidden-sm singleElement" style="top:calc(50% - ' + topOffset + 'px)"><div class="position-relative singleElement ' + arrowSizeClass + '">' + arrowSVG + '</div></div>';
	    		fullContentsHTML += '<span class="linkTextSaph hidden-xs ' + textClass + ' ' + textColor + '" data-text-color="' + textColor + '">' + text + '</span>';
	    		fullContentsHTML += '<span class="linkTextSaph visible-xs-inline '  + textClass + ' ' + textColor + '" data-text-color="' + textColor + '">' + smallText + '</span>';
	    	}
	    	if(isPositionRight)
	    	{
	    		fullContentsHTML += '<span class="linkTextSaph margin-right-30 hidden-xs ' + textClass + ' ' + textColor + '" data-text-color="' + textColor + '">' + text + '</span>';
	    		fullContentsHTML += '<span class="linkTextSaph margin-right-30 visible-xs-inline ' + textClass + ' ' + textColor + '" data-text-color="' + textColor + '">' + smallText + '</span>';
	    		fullContentsHTML += '<div class="linkButtonDiv link-arrow-left singleElement" style="top:calc(50% - ' + topOffset + 'px)"><div class="position-relative singleElement ' + arrowSizeClass + '">' + arrowSVG + '</div></div>';
	    	}
	    	fullContentsHTML += '</a></span>';

	    	$(this).append(fullContentsHTML);
	    	$(this).data("saph-done",true);
  	});
  }

})(jQuery);
